import { useQuery } from "@tanstack/react-query";
import { PAGE_IDS } from "src/shared/constants/PageIds";
import { useCreateQueryFn } from "src/shared/hooks/useCreateQueryFn";
import { createQueryKey } from "src/shared/utils/query-helpers";
import { QueryKeyPrefix } from "src/shared/utils/query/query-key-prefixes";
import type { CarouselSize } from "src/types/shared/common";
import { HOME_CAROUSEL_KEYS } from "src/website-apps/responsive/stubhub-home/components/HomeLayoutBody/constants";
import { CarouselId } from "src/website-apps/shared/components/carousel-module/carousel-analytics-event";
import { CarouselSize as CarouselSizeValues } from "src/website-apps/shared/components/CarouselSize";
import { GenericCategoryCarousel } from "src/website-apps/shared/components/GenericCategoryCarousel";
import { HOME_CAROUSEL_IDS } from "src/website-apps/shared/components/responsive-carousel/constants";

interface BecauseYouBrowsedResponse {
  readonly items: readonly Record<string, unknown>[];
  readonly seedCategoryName: string | null;
}

interface BecauseYouBrowsedOnHomeProps {
  readonly selectedCarouselGenre: number;
  readonly carouselSize: CarouselSize | undefined;
}

export const BecauseYouBrowsedOnHome = ({ selectedCarouselGenre, carouselSize }: BecauseYouBrowsedOnHomeProps) => {
  const createQueryFn = useCreateQueryFn();

  const { data } = useQuery<BecauseYouBrowsedResponse>({
    queryKey: createQueryKey(QueryKeyPrefix.BECAUSE_YOU_BROWSED_HOME, {
      selectedCarouselGenre,
    }),
    queryFn: createQueryFn({
      method: "BecauseYouBrowsedCategories",
      params: [],
    }),
    staleTime: Infinity,
  });

  if (!data?.items?.length) return null;

  const title = data.seedCategoryName
    ? `People who viewed ${data.seedCategoryName} also enjoyed`
    : "Because You Browsed";

  return (
    <GenericCategoryCarousel
      carouselId={HOME_CAROUSEL_IDS.becauseYouBrowsed}
      carouselKey={HOME_CAROUSEL_KEYS.HOME_BECAUSE_YOU_BROWSED}
      method=""
      carouselItems={data.items}
      title={title}
      carouselLocation={PAGE_IDS.HOME}
      size={carouselSize ?? CarouselSizeValues.REGULAR}
      analyticsCarouselId={CarouselId.BecauseYouBrowsed}
    />
  );
};
